// extracted by mini-css-extract-plugin
module.exports = {"support":"support_support__RIlX6","focus-visible":"support_focus-visible__sL9ld","submenu":"support_submenu__NY1CP","on":"support_on__x3JfK"};